import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import Content from "../../components/Content";
import { useAuthState } from "../../components/AuthProvider";
import Flex from "../../components/Flex";
import { requiresClient } from "../../components/AuthProvider";
import DataTable from "../../components/DataTable";
import DefaultBreadcrumbs from "../../components/DefaultBreadcrumbs";
import styles from "./DataQuality.module.scss";
import Spinner from "../../components/Loader/Spinner";

const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
const largeIdentityCountUrl = `${clientConfigApiDomain}/large_identities`;

const DataQuality = () => {
  const moment = require("moment-timezone");

  const { user } = useAuthState();
  const [largeIdentityData, setLargeIdentityData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const fetchLargeIdentityData = async id => {
    setIsLoading(false);

    const fetchLargeIdentityDataResponse = await fetch(
      `${largeIdentityCountUrl}/?client_oid=${id}`
    );
    const fetchLargeIdentityDataResponseData = await fetchLargeIdentityDataResponse;

    if (fetchLargeIdentityDataResponseData.status === 200) {
      const dataResults = await fetchLargeIdentityDataResponseData.json();
      var results = dataResults.results;
      results.sort((largeIdentityA, largeIdentityB) =>
        largeIdentityA.count >= largeIdentityB.count ? -1 : 1
      );
      setLargeIdentityData(dataResults.results);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    const selectedClientId = user.preferences.selectedClient.oid;
    fetchLargeIdentityData(selectedClientId);
  }, [user.preferences.selectedClient.oid]);

  const clickableCell = ({
    cell: {
      value,
      row: { original: selectGoldenId }
    }
  }) => {
    const onClick = () => {
      window.open(
        `/search-identities-new/${user.preferences.selectedClient.oid}/view/${selectGoldenId.golden_id}/#details`,
        "_blank"
      );
    };

    return (
      <span className={styles.cell} onClick={onClick}>
        {value}
      </span>
    );
  };

  function formattedTime(lastUpdated) {
    if (lastUpdated) {
      return moment(lastUpdated)
        .tz(user.preferences.timeZone)
        .format("L, LTS z");
    }
  }

  const columns = [
    {
      Header: "Golden Id",
      accessor: "golden_id",
      canSort: true,
      Cell: clickableCell
    },
    {
      Header: "Record Count",
      accessor: "count",
      canSort: true
    },
    {
      Header: "Updated",
      accessor: "updated_at",
      canSort: true,
      Cell: ({ value }) => formattedTime(value)
    }
  ];

  return (
    <Layout>
      <div className={styles.base}>
        <Container>
          <Flex gutter={3}>
            <Flex.Item span={12}>
              <DefaultBreadcrumbs />
            </Flex.Item>
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <Flex.Item span={12}>
                  <Content>
                    <h1>Large Identities</h1>
                    <p>
                      List of potentially large identities. Identities with more
                      than 50 records.
                    </p>
                  </Content>
                  <DataTable
                    columns={columns}
                    data={largeIdentityData}
                    hasPagination
                    hasSorting
                  />
                </Flex.Item>
              </>
            )}
          </Flex>
        </Container>
      </div>
    </Layout>
  );
};

export default requiresClient(DataQuality);
